var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.77894 3.5C3.42813 3.5 2.65706 5.04214 3.46754 6.12278C3.81346 6.58401 4.00045 7.14499 4.00045 7.72152V12C4.00045 13.7489 5.41822 15.1667 7.16712 15.1667H9.83379C11.5827 15.1667 13.0005 13.7489 13.0005 12V7.72152C13.0005 7.14499 13.1874 6.58401 13.5334 6.12278C14.3439 5.04214 13.5728 3.5 12.222 3.5H4.77894ZM9.83398 6.8335C10.1101 6.8335 10.334 7.05735 10.334 7.3335V11.3335C10.334 11.6096 10.1101 11.8335 9.83398 11.8335C9.55784 11.8335 9.33398 11.6096 9.33398 11.3335V7.3335C9.33398 7.05735 9.55784 6.8335 9.83398 6.8335ZM7.66699 7.33333C7.66699 7.05719 7.44313 6.83333 7.16699 6.83333C6.89085 6.83333 6.66699 7.05719 6.66699 7.33333L6.66699 11.3333C6.66699 11.6095 6.89085 11.8333 7.16699 11.8333C7.44313 11.8333 7.66699 11.6095 7.66699 11.3333V7.33333Z",
    fill: "#EA4646"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1663 4L10.8036 2.9117C10.6221 2.36724 10.1126 2 9.53866 2H7.46069C6.88678 2 6.37726 2.36724 6.19578 2.9117L5.83301 4",
    stroke: "#EA4646",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.37923e68a25ef8d2755bd1c13f5c9814.svg";
export { ForwardRef as ReactComponent };